import { HttpTypes } from '@/types';
import { thirdPartyAnalyticResponse } from '@/types/http';
import { AxiosInstance } from 'axios';

class ThirdPartyAnalytic {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async saveThirdPartyAnalytic(
    data: HttpTypes.thirdPartyAnalyticPayload
  ): Promise<HttpTypes.IResponse<thirdPartyAnalyticResponse>> {
    const result = await this.client.post('/sites/thirdparty-analytic', data);
    return result.data;
  }

  async getThirdPartyAnalytic() {
    const result = await this.client.get('/sites/analytic/thidparty');
    return result.data;
  }
}

export default ThirdPartyAnalytic;
